/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

try {
    // Load Bootstrap
    require('./libs/bootstrap');

    // Load Plugins
    require('jquery-mask-plugin');

    // Load Theme
    require('./libs/admin-lte');
} catch (e) {
    console.error(e);
}